import { render, staticRenderFns } from "./AfMenu.vue?vue&type=template&id=43e7bcb3"
import script from "./AfMenu.vue?vue&type=script&lang=ts"
export * from "./AfMenu.vue?vue&type=script&lang=ts"
import style0 from "./AfMenu.vue?vue&type=style&index=0&id=43e7bcb3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AfMenu.vue?vue&type=custom&index=0&blockType=af-menu"
if (typeof block0 === 'function') block0(component)

export default component.exports